import * as React from "react"
import Navbar from "./menu/Navbar"
import LogoNew from "@components/ImagesComponents/LogoNew"
import LogoMobileNew from "@components/ImagesComponents/LogoMobileNew"
import { BaseUrlLink} from "../helpers/baseUrl";

const Header = () => (
    <header className="header">
        <div className='header-wrapper'>
            <div className="header-left">
                <a href="/" className="logo">
                    <div className='logo-mobile-new'>
                        <LogoMobileNew />
                    </div>
                    <div className='logo-new'>
                        <LogoNew />
                    </div>
                </a>
                <Navbar />
            </div>
            <div className='header-info-phone'>
                <span className='flag-icon flag-icon-us'/>
                <p>(929) 339-1325</p>
                <span className="flare"/>
            </div>
            <div className="header-right">
                <a href={`${BaseUrlLink}/register`} className="button button-primary icon-btn-account" rel="nofollow">order now</a>
                <a href={`${BaseUrlLink}/login`} className="button button-secondary icon-btn-account" rel="nofollow">log in</a>
                {/*<div className='icon-account'>*/}
                {/*    <a href={`${BaseUrlLink}/login`} aria-label="Link"><Account /></a>*/}
                {/*</div>*/}
            </div>
        </div>
    </header>
)

export default Header
